<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="12">
        <app-publish-key-setting-form
          :saveLoading="saveLoading"
          @submit="save">
        </app-publish-key-setting-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import AppPublishKeySettingForm from '../../components/AppPublishKeySettingForm.vue';

export default {
  components: { AppPublishKeySettingForm },
  data() {
    return {
      saveLoading: false,
    };
  },
  methods: {
    ...mapActions({
      setAppPublishKeys: 'bookingChannel/setBookingChannelAppPublishKeys',
      showSuccess: 'globalMessages/addSuccess',
      showError: 'globalMessages/addError',
    }),
    async save(appPublishKeys) {
      this.saveLoading = true;
      try {
        await this.setAppPublishKeys({
          bookingChannelId: window.bookingChannelConfig.id,
          payload: appPublishKeys,
        });
        this.showSuccess({ message: 'appPublishKeySettings.settingAppPublishKeysSuccessfully' });
        this.saveLoading = false;
      } catch (error) {
        this.showError({ message: 'appPublishKeySettings.settingAppPublishKeysFailed' });
        this.saveLoading = false;
      }
    },
  },
};
</script>
